import axios from 'axios'

const GOOGLE_DRIVE_API = 'https://www.googleapis.com/drive/v3'

class GoogleDriveIntegration {
    constructor(googleAccessToken) {
        this.googleAccessToken = googleAccessToken
    }

    async listFiles(searchQuery = '') {
        console.log('googleAccessToken', this.googleAccessToken)
        try {
            const response = await axios.get(`${GOOGLE_DRIVE_API}/files`, {
                headers: {
                    'Authorization': `Bearer ${this.googleAccessToken}`,
                    'Content-Type': 'application/json'
                },
                params: {
                    q: searchQuery,
                    fields: 'files(id, name, mimeType, webViewLink)',
                    orderBy: 'modifiedTime desc',
                    // Only fetch Google Docs, Sheets, and Slides
                    mimeTypes: [
                        'application/vnd.google-apps.document',
                        'application/vnd.google-apps.spreadsheet',
                        'application/vnd.google-apps.presentation'
                    ].join(',')
                }
            })
            return response.data.files
        } catch (error) {
            throw new Error(`Failed to fetch Drive files: ${error.message}`)
        }
    }

    async getFileDetails(fileId) {
        try {
            const response = await axios.get(`${GOOGLE_DRIVE_API}/files/${fileId}`, {
                headers: {
                    'Authorization': `Bearer ${this.authToken}`,
                    'Content-Type': 'application/json'
                },
                params: {
                    fields: 'id, name, mimeType, webViewLink'
                }
            })
            return response.data
        } catch (error) {
            throw new Error(`Failed to get file details: ${error.message}`)
        }
    }
}

// Helper function to create an instance with the current user's token
export const createGoogleDriveIntegration = async () => {
    const googleAccessToken = localStorage.getItem('googleAccessToken')
    if (!googleAccessToken) {
        throw new Error('No authentication token found')
    }
    const integration = new GoogleDriveIntegration(googleAccessToken)
    
    try {
        const files = await integration.listFiles()
        console.log('Files:', files)
    } catch (error) {
        console.error('Error fetching files:', error)
    }
    
    return integration
}

export default GoogleDriveIntegration
